import footerlogo from "../images/footerlogo.svg";
import instagram from "../images/insta.svg";
import linkedin from "../images/linkedin.svg";
import whatsapp from "../images/whatsapp.svg";
import { MdEmail, MdPhone } from "react-icons/md";
const Footer = () => {
  return (
    <footer id="footer">
      <div className="container top-footer">
        <section className="footer-logo">
          <img src={footerlogo} alt="Gr8 Appers Logo" className="abs" />
          <p className="lgText">
            Discover Your True Potential
            <br /> with <b>Gr8 Appers!</b>
          </p>
        </section>
        <section className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a href="/skill-assessment">Skill Assessment</a>
            </li>

            <li>
              <a href="/study-abroad">Study Abroad</a>
            </li>
            <li>
              <a href="/about">About us</a>
            </li>
            <li>
              <a href="/privacy-policy">Privacy Policy</a>
            </li>
            <li>
              <a href="/terms-and-conditions">Terms of Service</a>
            </li>
          </ul>
        </section>
        <section className="social-links">
          <h4>Follow Us</h4>
          <div className="socials">
            <a
              href="https://www.instagram.com/gr8appers"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagram} alt="Instagram" />
            </a>
            <a
              href="https://www.linkedin.com/company/gr8appers"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="LinkedIn" />
            </a>
            <a
              href="https://wa.me/919042077338"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={whatsapp} alt="WhatsApp" />
            </a>
          </div>

          <ul>
            <li className="phone">
              <a href="tel:+91 90420 77338">
                <MdPhone />
                +91 90420 77338
              </a>
            </li>
            <li className="email">
              <a href="mailto:contact@gr8appers.com">
                <MdEmail/> contact@gr8appers.com
              </a>
            </li>
            {/* <li className="address">
              <a>
                <img src={location} alt="Address" /> 8-17, Yogeshwar Colony,<br/>
                Armoor, Nizamabad - 530224
              </a>
            </li> */}
          </ul>
        </section>
      </div>
      <div className="copy-footer">
        <div className="container">
          <p>© 2025 Copyrights Gr8 Appers All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
